import './bookDemoContent.scss';
import React, { useMemo } from 'react';
import Form from '../@bookDemoForm/bookDemoForm';
import { lang, _lang, isSystem } from '@umu/ukit-lang';
import { localStorageHelper, STORAGE_KEY } from '@umu/umu-storage';
import { BookDemoContentConfirmDialog } from '../@bookDemoContentConfirmDialog/bookDemoContentConfirmDialog';
import { FormType } from '../@bookDemoForm/bookDemoFormInterface';

interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
}

export const BookDemoContent = (props: IProp) => {
    localStorageHelper.set(STORAGE_KEY.AREA_CODE, '');

    const emailEle = useMemo(() => {
        if (isSystem('jp')) {
            return <a href={'mailto:support@umu.co'}>support@umu.co</a>;
        } else {
            return <a href={'mailto:support@umu.com'}>support@umu.com</a>;
        }
    }, []);

    return (
        <div
            className={
                props.platform === 'twww' ? 'contract-sales-content' : 'contract-sales-content contract-m-sales-content'
            }
        >
            <div className="content-form">
                <Form
                    type={FormType.bookDemo}
                    referUrl={props.referUrl}
                    platform={props.platform}
                    contentComponent={BookDemoContentConfirmDialog}
                />
            </div>
            <div className="content-wrapper">
                <div className="title">{lang('UMU 销售乐于为您：')}</div>
                <div className="help-des">
                    <div className="yes-icon"></div>
                    <div className="des">{lang('介绍产品，进行产品演示')}</div>
                </div>
                <div className="help-des">
                    <div className="yes-icon"></div>
                    <div className="des">{lang('量身定制专属解决方案')}</div>
                </div>
                <div className="help-des des-bottom">
                    <div className="yes-icon"></div>
                    <div className="des">{lang('协助合规流程和商务流程')}</div>
                </div>
                <div className="title">{lang('其他问题')}</div>
                <div className="des">
                    <span>{lang('如果有其他问题或者建议，欢迎发送邮件至')}</span>
                    {emailEle}
                    <span>{lang('，UMU 团队随时为您提供服务。')}</span>
                </div>
            </div>
        </div>
    );
};
